/**
 * Менеджер панели (урезанный доступ).
 * @param account — JWT или запись admin
 */
export const isPanelManager = (
  account: { is_admin?: boolean | null } | null | undefined
): boolean => {
  return account?.is_admin === false
}
